import { PropsWithChildren } from 'react';

import { H2 } from '@betterment/samba-react';
import { SystemStyleObject } from '@betterment/samba-styled-system/types';

interface BoxTitleProps extends PropsWithChildren {
  css?: SystemStyleObject;
}

export function BoxTitle({ children, css: cssProp }: BoxTitleProps) {
  return (
    <H2
      variant="title200"
      css={{
        paddingY: 'space.300',
        ...cssProp,
      }}
    >
      {children}
    </H2>
  );
}
